import { TaScheduleTypes } from '@medflex/shared-types';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';

const usePhoneOpeningHours = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const byType = useSelector(store.select.taConfigSchedules.byType);
  const openingHoursArray = useMemo(() => byType[TaScheduleTypes.OPENING_HOURS] || [], [byType]);
  const { taConfigSchedules: errors = {} } = useSelector(state => state.errors);

  const refresh = useCallback(() => {
    dispatch.taConfigSchedules.load({
      type: TaScheduleTypes.OPENING_HOURS,
    });
  }, [dispatch]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const phoneOpeningHours = useMemo(() => {
    if (!openingHoursArray.length)
      return {
        active: false,
        weekdays: Array(7)
          .fill({ active: true, slots: [{ startTime: '00:00', endTime: '23:59' }] })
          .map((value, idx) => ({ ...value, day: idx === 6 ? 0 : idx + 1 })),
        outputType: '',
      };

    return openingHoursArray[0];
  }, [openingHoursArray]);

  const createOrEditOpeningHours = useCallback(
    async payload => {
      if (!openingHoursArray.length) {
        await dispatch.taConfigSchedules.create({
          ...payload,
          type: TaScheduleTypes.OPENING_HOURS,
        });
        return;
      }

      await dispatch.taConfigSchedules.edit({
        ...payload,
        type: TaScheduleTypes.OPENING_HOURS,
      });
    },
    [dispatch, openingHoursArray],
  );

  return {
    phoneOpeningHours,
    createOrEditOpeningHours,
    errors,
  };
};

export default usePhoneOpeningHours;
